import EventBus from '@/services/eventbus.service';

export function debounce<T extends (...args: any[]) => void>(cb: T, wait = 20) {
  let h: any = 0;
  const callable = (...args: any) => {
    clearTimeout(h);
    h = setTimeout(() => cb(...args), wait);
  };
  return (callable as any) as T;
}

// NOTE: This must be called by user initiated event
export function copyToClipboard(text: string): boolean {
  try {
    const win = (window as any);
    // Check for modern clipboard API
    if (win.clipboardData && win.clipboardData.setData) {
      return win.clipboardData.setData('Text', text) as boolean;  // Security exception may be thrown
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      const textarea = document.createElement('textarea');
      textarea.addEventListener('focusin', (e) => e.stopPropagation()); // Dialog fix
      textarea.textContent = text;
      textarea.style.position = 'fixed';  // Prevent scrolling to bottom of page.
      document.body.appendChild(textarea);
      try {
        textarea.select();
        EventBus.$emit('showGenericSnackbar', {text: 'Successfully copied to clipboard.', icon: 'mdi-clipboard'});
        return document.execCommand('copy');  // Security exception may be thrown.
      } finally {
        document.body.removeChild(textarea);
      }
    }
  } catch (ex) {
    // tslint:disable-next-line
    console.warn('Copy to clipboard failed.', ex);
    return false;
  }
  // tslint:disable-next-line
  console.warn('Copy to clipboard failed as it is unsupported!');
  return false;
}
